export function parseSplitAmount(value) {
  const normalized = String(value || "")
    .trim()
    .replace(/\s/g, "")
    .replace(",", ".");
  const amount = Number(normalized);
  return Number.isFinite(amount) ? amount : 0;
}

export function expandTransactionParts(tx) {
  const parts = [
    {
      ...tx,
      amount: tx.amount,
    },
  ];
  (tx.splits || []).forEach((split) => {
    parts.push({
      ...tx,
      transaction_uuid: split.split_uuid,
      amount: split.amount,
      category_uuid: split.category_uuid,
      category_name: split.category_name,
      parent_category_uuid: split.parent_category_uuid,
      parent_category_name: split.parent_category_name,
      match_text: split.label || tx.match_text,
      splits: [],
    });
  });
  return parts;
}
